<script>
  import helpers from '@mixins/helper'

  import {required} from 'vuelidate/lib/validators'

  import NavigationButtons from './NavigationButtons'

  import * as restfulService from '../../../services/restfulService'

  import swal from 'sweetalert2'

  import bus from '@utils/bus'

  export default {
    mixins: [helpers],
    components: {NavigationButtons},
    name: 'confirmacao',
    props: {
      dados: {
        required: true,
        type: Object,
        default: () => ({})
      },
      etapaAtiva: {
        type: Number,
        required: true
      },
      desabilita: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {}
    },
    validations: {
      dadosMatricula: {
        matricula: {
          parcelamento: {required}
        }
      }
    },
    computed: {
      dadosMatricula: {
        get () {
          return this.dados
        },
        set (value) {
          this.$emit('update:dados', value)
        }
      },
      disciplinasSemCpp: {
        get () {
          return this.dados.matricula.contrato.disciplinas.filter(item => item.tipo_matriz !== 'CPP')
        }
      },
      disciplinasCPP: {
        get () {
          return this.dados.matricula.contrato.disciplinas.find(item => item.tipo_matriz === 'CPP')
        }
      }
    },
    methods: {
      salvarDados () {
        swal({
          title: this.dados.matricula.intencaoVaga.intencao ? 'Concluir inscrição?' : 'Concluir pré-matrícula?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#4caf50',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não'
        }).then((result) => {
          if (result) {
            bus.$emit('show-loader')
            bus.$emit('desabilitaConfirma')
            restfulService.post('matricula-online', 'confirma', null, this.dados.matricula)
            .then((response) => {
              bus.$emit('hide-loader')
              this.dadosMatricula.matricula.titulo = response.titulo
              swal({
                title: 'Sucesso',
                html: response.success,
                type: 'success',
                allowEscapeKey: false,
                allowOutsideClick: false
              })
              .then((value) => {
                this.desabilita.aba5 = true
                this.desabilita.aba6 = false
                this.$emit('update:desabilita', this.desabilita)
                this.$emit('update:etapaAtiva', (this.etapaAtiva + 1))
              })
            })
            .catch(e => {
              bus.$emit('hide-loader')
              console.log(e)
            })
          }
        }).catch(e => {
          console.log(e)
        })
        bus.$emit('hide-loader')
      },
      voltar () {
        this.desabilita.aba4 = false
        this.desabilita.aba5 = true
        this.$emit('update:etapaAtiva', (this.etapaAtiva - 1))
        this.$emit('update:desabilita', this.desabilita)
      }
    }
  }
</script>

<template>
    <v-container fluid grid-list-md :pa-0="$vuetify.breakpoint.xsOnly">
        <v-layout row wrap>
            <v-flex xs12>
                <v-card flat color="grey lighten-4">
                    <v-card-text>
                        <h4 class="title mb-2">Curso</h4>
                        <div class="subheading">
                            <v-chip color="primary" style="font-size: 16px;"
                                    class="white--text">
                                {{dadosMatricula.matricula.contrato.descricao}}
                            </v-chip>
                            <v-chip color="secondary" class="white--text">{{dadosMatricula.matricula.descricao}}</v-chip>
                        </div>
                        <v-divider class="mt-4 mb-4"></v-divider>
                        <div>
                            <h4 class="title mb-2">Disciplinas ¹</h4>
                            <v-chip v-for="disciplina in disciplinasSemCpp"
                                    color="primary"
                                    outline>
                                <span class="disciplina">{{disciplina.descricao}}</span>
                            </v-chip>
                            <v-chip v-if="dadosMatricula.matricula.contrato.cpp.descricao" color="primary"
                                    outline>
                                <span class="disciplina">{{dadosMatricula.matricula.contrato.cpp.descricao}} (<strong>*CPP</strong>)</span>
                            </v-chip>
                        </div>

                        <div v-if="dadosMatricula.matricula.incentivos.length">
                          <v-divider class="mt-4 mb-4"></v-divider>
                          <h4 class="title mb-2">Incentivos ²</h4>
                          <v-chip v-for="item in dadosMatricula.matricula.incentivos" color="primary"outline>
                                <span class="disciplina">{{item}}</span>
                          </v-chip>
                        </div>
                        <v-divider class="mt-4 mb-4"></v-divider>
                        <div>
                            <h4 class="title mb-3">Pagamento ² ³</h4>
                            <div class="title font-weight-light" v-if="dadosMatricula.matricula.parcelas">
                              <template v-if="dadosMatricula.matricula.parcelas.quantidade > 1" v-for="item in dadosMatricula.matricula.parcelas.detalhes">
                                <span v-if="item.numeroParcela == 1"> {{item.numeroParcela}}x de R$ {{item.valorUnitario | currencyEnToBr}} + {{dadosMatricula.matricula.parcelas.quantidade -1}}x de R$ {{dadosMatricula.matricula.parcelas.valor | currencyEnToBr}}</span>
                              </template>
                              <template v-if="dadosMatricula.matricula.parcelas.quantidade == 1">
                                {{dadosMatricula.matricula.parcelas.quantidade}}x de R$ {{dadosMatricula.matricula.parcelas.valor | currencyEnToBr}}
                              </template>

                            </div>
                        </div>
                        <v-divider class="mt-4 mb-4"></v-divider>
                        <div>
                          <h4 class="title mb-3">Mensagens Importantes</h4>
                          <div>
                            <p>¹ Após a confirmação da matrícula não será permitida a troca da disciplina escolhida na CPP (Ignore se você não selecionou nenhuma);</p>
                            <p>² Caso alguma informação estiver incorreta, ou vocẽ tenha alguma dúvida, não conclua esta etapa e dirija-se à Central de Atendimento do seu Câmpus;</p>
                            <p v-if="dadosMatricula.matricula.intencaoVaga.intencao">³ Não esqueça, esse é um pagamento de Intenção de Vaga</p>
                            <p v-else>³ Verifique os valores dos descontos de pontualidade na mensagem dos boletos;</p>
                          </div>
                        </div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <div class="flex-header">
            <navigation-buttons
              :show-previous="true"
              :show-next="true"
              :previous-click="voltar"
              :next-click="salvarDados"
              :disable-next="$v.dadosMatricula.$invalid"
              :confirm="true">
            </navigation-buttons>
        </div>
    </v-container>
</template>
<style scoped lang="scss">

  @media all and (max-width: 1200px) {
    .disciplina {
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;

    }
    .v-chip.v-chip.v-chip--outline {
      height: auto !important;
      padding: 5px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// Confirmacao.vue?8a3ea140